import React from 'react';
import styled from 'styled-components';
import colors from '../common/theme/colors';
import KitIcon from './KitIcon';
import constants from '../common/theme/constants';

const StyledSearchIcon = styled(KitIcon)`
  cursor: pointer;
  color: ${colors.gray_50};
  :hover {
    color: ${colors.black};
  }
`;

const KitSearchIcon = () => <StyledSearchIcon icon='magnify' size={`${constants.iconSize.m}rem`} />;

export default KitSearchIcon;
